import { styled } from '@mui/material/styles';

export const CompetenceEditor = styled('div')(() => ({
  // width:100%;
  '& .column-width-competence': {
    width: '100%'
  }
  // ... commented out media queries ...
}));

export const CompetenceTextArea = styled('div')(() => ({
  width: '85%',
  '@media screen and (min-width:768px) and (max-width:959px)': {
    width: '100%',
    marginBottom: '15px'
  },
  '@media screen and (max-width:767px)': {
    width: '100%',
    marginBottom: '15px'
  },
  '& .limit-industryFocuses-box, & .limit-specialistFocuses-box, & .limit-managementMethods-box': {
    transition: 'height 3s',
    height: '172px'
  },
  '& .industryFocuses-box, & .specialistFocuses-box, & .managementMethods-box': {
    transition: 'height 3s'
  }
}));

export const Label = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.base,
  marginBottom: theme.spacing(1),
  fontWeight: theme.fontWeight.bold
}));

export const TogglerContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: theme.spacing(3)
}));

export const Button = styled('button')(() => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  padding: 0,
  '&:focus': {
    outline: 'none'
  }
}));

export const IconLabel = styled('span')(({ theme }) => ({
  fontWeight: theme.fontWeight.normal,
  marginRight: theme.spacing(0.5)
}));

export const ToggleIcon = styled('span')(() => ({
  fontSize: '2em',
  transform: 'rotate(270deg)'
}));

export const EmptySection = styled('div')(({ theme }) => ({
  border: `1px dashed ${theme.color.grey[500]}`,
  borderRadius: theme.borderRadius.base,
  boxSizing: 'border-box',
  padding: theme.spacing(3)
}));

export const EmptyText = styled('p')(() => ({
  lineHeight: '1.5em',
  margin: 0
}));

